import React, { FC } from 'react';
import VideoList from './videoList';
import { useFetchVideos } from '../../videos/hooks/useFetchVideos';

interface Props {
  selectedVideos: Array<number>;
  onVideoSelect: (videoFileId: number) => void;
}

const TdcVideos: FC<Props> = (props) => {
  const response = useFetchVideos('TDC');
  return <VideoList {...response} {...props} />;
};

export default TdcVideos;
